import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {NotificationMobileOverviewPageComponent} from '@presentation/pages/notifications/notification-mobile-overview-page/notification-mobile-overview-page.component';

export const notificationRoutes: Routes = [{path: RouteUtils.paths.notifications.path, component: NotificationMobileOverviewPageComponent}];

export const notificationRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(notificationRoutes);
